/* ============================================================
   MAISON52 — affichage des promos en cours (les remises elles-mêmes sont des
   remises automatiques Shopify, appliquées au panier / paiement).
   1) Bandeau défilant noir au-dessus du header (toutes les pages).
   2) Encart promo sur les fiches produit hors packs, juste au-dessus du bouton panier
      (les pièces tracksuit / short / denim ont le bloc « Offre spéciale » de m52-offer.js).
   Pour changer une offre : modifier OFFERS / les listes ci-dessous.
   ============================================================ */
(function () {
  var FR = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;

  var SHOES = [10306070774099, 10306073723219];
  var PACK_PIECES = [
    10490216218963, 10490217398611, 10545624514899, 10545628414291, 10753678213459, 10753678803283, 10844536078675,
    10232340218195, 10232342741331, 10753571717459, 10753577615699, 10844538798419,
    10753568407891, 10753569227091, 10844539289939, 10013713105235, 10013718610259,
    10229450309971, 10570666541395, 10229448769875, 10353903862099, 10569535357267
  ];
  var GIFTS = [10276470489427, 10570669621587, 10879191679315, 10879192269139];

  var OFFERS = FR ? [
    '−15 % sur un haut + un bas tracksuit · toutes couleurs',
    'Zip + jogging couleur : le bermuda assorti à −52 %',
    '−15 % sur l’ensemble veste en jean + jean',
    '−20 % sur 2 paires de DoubleTongue',
    'Hand spinner offert dès 210 € + boxer offert dès 320 €'
  ] : [
    '−15% on a tracksuit top + bottom · any colour',
    'Coloured zip + jogger: matching bermuda −52% off',
    '−15% on a denim jacket + jeans set',
    '−20% on 2 pairs of DoubleTongue',
    'Free hand spinner from €210 + free boxers from €320'
  ];

  function css() {
    if (document.getElementById('m52PromoCss')) return;
    var st = document.createElement('style');
    st.id = 'm52PromoCss';
    st.textContent =
      '.m52-promobar{background:#000;color:#fff;text-align:center;font-size:11px;letter-spacing:.12em;text-transform:uppercase;height:32px;line-height:32px;overflow:hidden;position:relative;font-family:"Hanken Grotesk",Arial,sans-serif}' +
      '.m52-promobar__msg{position:absolute;left:0;right:0;top:0;padding:0 12px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;opacity:0;transform:translateY(8px);transition:opacity .35s ease,transform .35s ease}' +
      '.m52-promobar__msg.is-on{opacity:1;transform:none}' +
      '.m52-promobox{border:1.5px solid #111;border-radius:10px;padding:11px 14px;margin:0 0 12px;font-size:13px;line-height:1.45;color:#111;background:#fff;text-align:left;width:100%;box-sizing:border-box}' +
      '.m52-promobox b{display:block;font-size:12px;letter-spacing:.1em;text-transform:uppercase;margin-bottom:3px}' +
      '.m52-promobox small{display:block;color:#666;font-size:12px;margin-top:4px}';
    document.head.appendChild(st);
  }

  function bar() {
    var header = document.getElementById('shopify-section-header');
    if (!header || document.querySelector('.m52-promobar')) return;
    var el = document.createElement('div');
    el.className = 'm52-promobar';
    el.setAttribute('role', 'region');
    el.setAttribute('aria-label', FR ? 'Offres en cours' : 'Current offers');
    OFFERS.forEach(function (txt, i) {
      var m = document.createElement('div');
      m.className = 'm52-promobar__msg' + (i === 0 ? ' is-on' : '');
      m.textContent = txt;
      el.appendChild(m);
    });
    header.insertBefore(el, header.firstChild);
    var i = 0, msgs = el.children;
    setInterval(function () {
      msgs[i].classList.remove('is-on');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-on');
    }, 3500);
  }

  function box() {
    var meta = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
    if (!meta || document.querySelector('.m52-promobox') || document.querySelector('.m52-offer')) return;
    var id = +meta.id;
    if (PACK_PIECES.indexOf(id) >= 0 || GIFTS.indexOf(id) >= 0) return;
    var btn = document.querySelector('.product-info__cart-btn') || document.querySelector('form[action*="/cart/add"] [type=submit]');
    if (!btn) return;
    var shoes = SHOES.indexOf(id) >= 0;
    var title = shoes ? (FR ? '−20 % dès 2 paires' : '−20% on 2 pairs') : (FR ? 'Cadeaux offerts' : 'Free gifts');
    var text = shoes
      ? (FR ? 'Ajoute 2 paires de DoubleTongue (même modèle ou mix) : −20 % appliqués automatiquement au panier.' : 'Add 2 pairs of DoubleTongue (same or mixed): −20% applied automatically in your cart.')
      : (FR ? 'Hand spinner offert dès 210 €, et boxer offert en plus dès 320 €.' : 'Free hand spinner from €210, plus free boxers from €320.');
    var el = document.createElement('div');
    el.className = 'm52-promobox';
    el.innerHTML = '<b>' + title + '</b>' + text;
    btn.parentNode.insertBefore(el, btn.nextSibling);
  }

  function init() { css(); bar(); box(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
